export function mapWindSpeedToClass(s) {
    if (s == -9999) {
        return "no-data";
    } else if (s < 10) {
        return "wind-speed-0-10";
    } else if (s < 20) {
        return "wind-speed-10-20";
    } else if (s < 30) {
        return "wind-speed-20-30";
    } else if (s < 40) {
        return "wind-speed-30-40";
    } else if (s < 50) {
        return "wind-speed-40-50";
    } else if (s < 60) {
        return "wind-speed-50-60";
    } else if (s < 70) {
        return "wind-speed-60-70";
    } else {
        return "wind-speed-70";
    }
}

/**
 * Maps temperature values to class-names.
 * @param {*} t The temperature value to map 
 * @returns 
 */
export function mapTempToClass(t) {
    if (t == -9999) {
        return "no-data";
    } else if (t < -3) {
        return "temp-m6";
    } else if (t < 0) {
        return "temp-m3";
    } else if (t < 3) {
        return "temp-0";
    } else if (t < 6) {
        return "temp-3";
    } else if (t < 9) {
        return "temp-6";
    } else if (t < 12) {
        return "temp-9";
    } else if (t < 15) {
        return "temp-12";
    } else if (t < 18) {
        return "temp-15";
    } else if (t < 21) {
        return "temp-18";
    } else if (t < 24) {
        return "temp-21";
    } else if (t < 27) {
        return "temp-24";
    } else if (t < 30) {
        return "temp-27";
    } else if (t < 33) {
        return "temp-30";
    } else if (t < 36) {
        return "temp-33";
    } else if (t < 39) {
        return "temp-36";
    } else if (t < 42) {
        return "temp-39";
    } else if (t < 45) {
        return "temp-42";
    } else {
        return "temp-45";
    }
}

export function MapFbiToHtmlColor(fbiVal) {
    if (fbiVal < 6) {
        return "#542788";
    } else if (fbiVal < 12) {
        return "#998EC3";
    } else if (fbiVal < 24) {
        return "#D8DAEB";
    } else if (fbiVal < 50) {
        return "#FCE2AC";
    } else if (fbiVal < 100) {
        return "EF8A62";
    } else {
        return "#B2182B";
    }
    return "white";
}

/**
 * Maps the FBI value to class-names
 * @param {*} g The FBI value to map
 * @returns 
 */
export function mapFbiToClass(g) {
    if (g == -9999) {
        return "no-data";
    } else if (g < 6) {
        return "fbi-6";
    } else if (g < 12) {
        return "fbi-12";
    } else if (g < 24) {
        return "fbi-24";
    } else if (g < 50) {
        return "fbi-50";
    } else if (g < 100) {
        return "fbi-100";
    } else {
        return "fbi-101";
    }
}

export function mapFdrToHtmlColor(fdrVal) {
    if (fdrVal == 0) {
        return "#FFFFFF";
    } else if (fdrVal == 1) {
        return "#64BF30";
    } else if (fdrVal == 2) {
        return "#FEDD3A";
    } else if (fdrVal == 3) {
        return "#F78100";
    } else if (fdrVal == 4) {
        return "#AD0909";
    } else {
        return "#FFFFFF";
    }    
}

/**
 * Maps FDR values to class-names
 * @param {*} f The FDR value to map
 * @returns 
 */
export function mapFdrToClass(f) {
    if (f == 0) {
        return "fdr-0";
    } else if (f == 1) {
        return "fdr-1";
    } else if (f == 2) {
        return "fdr-2";
    } else if (f == 3) {
        return "fdr-3";
    } else if (f == 4) {
        return "fdr-4";
    }else {
        return "no-data";
    }
}